module.exports = __webpack_public_path__ + "static/bg-showcase-1-dbfff7f304afb1dc5bbd81a3ddba1cb0.jpg";